import React from "react"
import getLogger from "../components/Logging"

const log = getLogger("ReactUtils")

export function simpleReducer(state, action) {
    state = {...state, ...action}
    return state
}

// export function pathReducer(state, action) {
//     const { path, value } = action;
//
//     if (path === ".") {
//         // Replace the entire state
//         return { ...value };
//     }
//
//     // Handle nested updates
//     const keys = path.split('.');
//     const updatedState = { ...state };
//     let current = updatedState;
//
//     for (let i = 0; i < keys.length - 1; i++) {
//         const key = keys[i];
//         current[key] = current[key] || {};
//         current = current[key];
//     }
//
//     current[keys[keys.length - 1]] = value;
//
//     return updatedState;
// }

export function pathReducer(state, action) {
    const { path, value } = action;

    if (path === ".") {
        return { ...value };
    }

    // Parse path into tokens (keys or array indices)
    const tokens = [];
    const regex = /([^[.\]]+)|\[(\d*)\]/g;
    let match;

    while ((match = regex.exec(path))) {
        if (match[1] !== undefined) {
            tokens.push(match[1]);
        }
        else if (match[2] === "") {
            tokens.push("[]"); // append marker
        }
        else {
            tokens.push(Number(match[2])); // numeric index
        }
    }

    const updatedState = Array.isArray(state) ? [...state] : { ...state };
    let current = updatedState;

    for (let i = 0; i < tokens.length - 1; i++) {
        const token = tokens[i];
        const nextToken = tokens[i + 1];

        if (token === "[]") {
            throw new Error("Append ([]) not allowed in the middle of a path");
        }

        if (typeof token === "number") {
            if (!Array.isArray(current)) {
                throw new Error(`Expected array at ${tokens.slice(0, i).join('.')}`);
            }
            // Expand array if index out of bounds
            while (current.length <= token) {
                current.push(undefined);
            }
            current[token] = Array.isArray(current[token])
              ? [...current[token]]
              : (typeof current[token] === "object" && current[token] !== null
                ? { ...current[token] }
                : (typeof nextToken === "number" || nextToken === "[]" ? [] : {}));
            current = current[token];
        } else {
            if (!(token in current)) {
                current[token] = typeof nextToken === "number" || nextToken === "[]" ? [] : {};
            }
            else {
                current[token] = Array.isArray(current[token])
                  ? [...current[token]]
                  : { ...current[token] };
            }
            current = current[token];
        }
    }

    const lastToken = tokens[tokens.length - 1];
    if (lastToken === "[]") {
        if (!Array.isArray(current)) {
            throw new Error(`Expected array for append at ${path}`);
        }
        current.push(value);
    }
    else if (typeof lastToken === "number") {
        if (!Array.isArray(current)) {
            throw new Error(`Expected array at ${path}`);
        }
        // Expand array if index out of bounds
        while (current.length <= lastToken) {
            current.push(undefined);
        }
        current[lastToken] = value;
    }
    else {
        current[lastToken] = value;
    }

    return updatedState;
}


export function booleanProp(props, name, defaultValue = false) {
    let value = null
    switch (typeof(props)) {
        case "boolean":
            return (!!props)
            break
        case "object":
            if (props === null) {
                return defaultValue
            }
            const key = Object.keys(props).find(k => k.toLowerCase() === name.toLowerCase())
            if (!key) {
                return defaultValue
            }
            value = props?.[name]
            // console.log(">>>Z: booleanProp: ", name, key, value, Object.keys(props).join(","))
            return attrTrueValue(name, value, defaultValue)
        default:
            return defaultValue
    }
}

export function attrTrueValue(attrName, value, defaultValue) {
    switch (typeof (value)) {
        case "object":
            if (value !== null) {
                return true
            }
            else {
                return defaultValue
            }
        case "boolean":
            return (value === true)
        case "string":
            return ["TRUE", "YES", "ON", attrName?.toUpperCase()].includes(value.toUpperCase())
        default:
            return defaultValue
    }
}


export function isNullOrUndefined(v) {
    return (v === null || v === undefined)
}

// Flatten children, handling React.Fragment
export function flattenChildren(children) {
    return React.Children.toArray(children).flatMap((child) =>
      React.isValidElement(child) && child.type === React.Fragment
        ? flattenChildren(child.props.children)  // Recursively flatten fragments
        : child
    );
}

// Find children by type (ignores fragments)
export function findChildren(children, type) {
    const flatChildren = flattenChildren(children);
    return flatChildren.filter((child) => React.isValidElement(child) && child.type === type);
}

// Add props to children
export function addPropsToChildren(children, extraProps) {
    return React.Children.map(children, (child) =>
      React.isValidElement(child) ? React.cloneElement(child, extraProps) : child
    );
}
